import Vue from 'vue'
import iDalgoComponents from 'idalgo-components'
import iDalgoModules from 'idalgo-components/lib/iDalgoModules.common'

Vue.use(iDalgoComponents)
Vue.use(iDalgoModules, { env: process.env.NODE_ENV || 'production' })
